/**
 * question接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const question = {
  getQuestions (params) {
    return axios.get('/api/question/GetQuestions', { params })
  },
  getQuestion (params) {
    return axios.get('/api/question/GetQuestion', { params })
  },
  editQuestion (params) {
    return axios.post('/api/question/EditQuestion', params)
  },
  deleteQuestion (params) {
    return axios.delete('/api/question/DeleteQuestion', { params })
  },
  exportProjectTemplate (params) {
    return axios({
      method: 'post',
      url: '/api/question/ExportProjectTemplate',
      data: params,
      responseType: 'blob'
    })
  }
}

export default question
